

import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('frame-ready', init)

function init() {
    const PAGE = document.querySelector('.NutritionPage')
    if(!PAGE) return

    const Flairs = document.querySelector('.flair-wrapper')
    if(!Flairs) return

    const Hero = document.querySelector('.nutrition-hero')

    const Yoghurt = Flairs.querySelector('.flair-greek')
    const Milk = Flairs.querySelector('.flair-milk')
    const Paste = Flairs.querySelector('.flair-paste')
    const Tree = Flairs.querySelector('.flair-tree')

    const Intro = Hero.querySelector('.nutrition-hero--intro')
    const Items = Hero.querySelectorAll('.nutrition-hero--items > div')


    // Hero in animation
    {
        const tl = gsap.timeline({
            ease: "Power2.easeIn"
        })

        tl.to(Yoghurt, { translateX: 0, translateY: 0 }, "<")
            .to(Milk, { translateX: 0, translateY: 0, rotate: -30, opacity: 1}, "<")
            .to(Paste, { translateX: 0, translateY: 0, rotate: -30 }, "<")
            .to(Tree, { translateX: 0, translateY: 0, rotate: -15, opacity: 1}, "<")
            .to(Intro, { translateY: 0, opacity: 1 }, "<")
            .to(Items, { stagger: 0.1, translateY: 0, opacity: 1 })

        //.to(Hero, { backgroundPosition: 'center 0' })
    }

    // Scroll animation
    {
        const tl = gsap.timeline({
            ease: "Power2.easeIn",
            scrollTrigger: {
                trigger: Hero,
                start: 'center top',
                scrub: true
            }
        })

        tl.to(Yoghurt, { translateX: '80%', translateY: -20, rotate: 140 }) }
}
